import { type SVGProps } from "react";

// Icons from the onboarding Figma ("Icon / heart", "Icon / spray-can", ...),
// drawn from the design's own stroke paths. They stroke with currentColor, so
// CSS sets the colour.
type IconData = { size: number; strokeWidth: number; paths: string[] };

const ICONS = {
  lipsticks_and_lip_gloss: {
    size: 18,
    strokeWidth: 1.5,
    paths: [
      "M14.25 10.5C15.3675 9.405 16.5 8.0925 16.5 6.375C16.5 5.28098 16.0654 4.23177 15.2918 3.45818C14.5182 2.6846 13.469 2.25 12.375 2.25C11.055 2.25 10.125 2.625 9 3.75C7.875 2.625 6.945 2.25 5.625 2.25C4.53098 2.25 3.48177 2.6846 2.70818 3.45818C1.9346 4.23177 1.5 5.28098 1.5 6.375C1.5 8.1 2.625 9.4125 3.75 10.5L9 15.75L14.25 10.5Z",
    ],
  },
  eyeshadow_and_eyes: {
    size: 18,
    strokeWidth: 2,
    paths: [
      "M1.5465 9.261C1.48399 9.09261 1.48399 8.90739 1.5465 8.739C2.15528 7.26289 3.18864 6.00078 4.51558 5.11267C5.84252 4.22457 7.40328 3.75046 9 3.75046C10.5967 3.75046 12.1575 4.22457 13.4844 5.11267C14.8114 6.00078 15.8447 7.26289 16.4535 8.739C16.516 8.90739 16.516 9.09261 16.4535 9.261C15.8447 10.7371 14.8114 11.9992 13.4844 12.8873C12.1575 13.7754 10.5967 14.2495 9 14.2495C7.40328 14.2495 5.84252 13.7754 4.51558 12.8873C3.18864 11.9992 2.15528 10.7371 1.5465 9.261Z",
      "M11.25 9C11.25 10.2426 10.2426 11.25 9 11.25C7.75736 11.25 6.75 10.2426 6.75 9C6.75 7.75736 7.75736 6.75 9 6.75C10.2426 6.75 11.25 7.75736 11.25 9Z",
    ],
  },
  face_and_foundation: {
    size: 18,
    strokeWidth: 1.5,
    paths: [
      "M10.125 5.25C10.3321 5.25 10.5 5.08211 10.5 4.875C10.5 4.66789 10.3321 4.5 10.125 4.5C9.91789 4.5 9.75 4.66789 9.75 4.875C9.75 5.08211 9.91789 5.25 10.125 5.25Z",
      "M13.125 8.25C13.3321 8.25 13.5 8.08211 13.5 7.875C13.5 7.66789 13.3321 7.5 13.125 7.5C12.9179 7.5 12.75 7.66789 12.75 7.875C12.75 8.08211 12.9179 8.25 13.125 8.25Z",
      "M6.375 6C6.58211 6 6.75 5.83211 6.75 5.625C6.75 5.41789 6.58211 5.25 6.375 5.25C6.16789 5.25 6 5.41789 6 5.625C6 5.83211 6.16789 6 6.375 6Z",
      "M4.875 9.75C5.08211 9.75 5.25 9.58211 5.25 9.375C5.25 9.16789 5.08211 9 4.875 9C4.66789 9 4.5 9.16789 4.5 9.375C4.5 9.58211 4.66789 9.75 4.875 9.75Z",
      "M9 1.5C4.875 1.5 1.5 4.875 1.5 9C1.5 13.125 4.875 16.5 9 16.5C9.6945 16.5 10.236 15.9405 10.236 15.234C10.236 14.9063 10.101 14.6078 9.90825 14.3903C9.69075 14.1735 9.57975 13.9013 9.57975 13.5465C9.57691 13.3814 9.60732 13.2175 9.66918 13.0644C9.73105 12.9114 9.82309 12.7723 9.93983 12.6556C10.0566 12.5388 10.1956 12.4468 10.3487 12.3849C10.5017 12.3231 10.6657 12.2927 10.8307 12.2955H12.3278C14.616 12.2955 16.494 10.4183 16.494 8.13C16.4738 4.509 13.0957 1.5 9 1.5Z",
    ],
  },
  skincare: {
    size: 18,
    strokeWidth: 1.5,
    paths: [
      "M9 16.5C10.3924 16.5 11.7277 15.9469 12.7123 14.9623C13.6969 13.9777 14.25 12.6424 14.25 11.25C14.25 9.75 13.5 8.325 12 7.125C10.5 5.925 9.375 4.125 9 2.25C8.625 4.125 7.5 5.925 6 7.125C4.5 8.325 3.75 9.75 3.75 11.25C3.75 12.6424 4.30312 13.9777 5.28769 14.9623C6.27226 15.9469 7.60761 16.5 9 16.5Z",
    ],
  },
  serums_and_face_oils: {
    size: 18,
    strokeWidth: 2,
    paths: [
      "M7.5 1.5V7.14525C7.50022 7.37851 7.44603 7.6086 7.34175 7.81725L3.54 15.4125C3.48218 15.5272 3.4548 15.6549 3.4605 15.7833C3.4662 15.9116 3.50477 16.0364 3.57253 16.1455C3.64029 16.2547 3.73496 16.3446 3.84746 16.4067C3.95996 16.4688 4.08652 16.5009 4.215 16.5H13.785C13.9135 16.5009 14.04 16.4688 14.1525 16.4067C14.265 16.3446 14.3597 16.2547 14.4275 16.1455C14.4952 16.0364 14.5338 15.9116 14.5395 15.7833C14.5452 15.6549 14.5178 15.5272 14.46 15.4125L10.6583 7.81725C10.554 7.6086 10.4998 7.37851 10.5 7.14525V1.5",
      "M6.375 1.5H11.625",
      "M5.25 12H12.75",
    ],
  },
  hair_care: {
    size: 18,
    strokeWidth: 1.5,
    paths: [
      "M6.75 4.5C6.75 5.74264 5.74264 6.75 4.5 6.75C3.25736 6.75 2.25 5.74264 2.25 4.5C2.25 3.25736 3.25736 2.25 4.5 2.25C5.74264 2.25 6.75 3.25736 6.75 4.5Z",
      "M6.09 6.09L9 9",
      "M15 3L6.09 11.91",
      "M6.75 13.5C6.75 14.7426 5.74264 15.75 4.5 15.75C3.25736 15.75 2.25 14.7426 2.25 13.5C2.25 12.2574 3.25736 11.25 4.5 11.25C5.74264 11.25 6.75 12.2574 6.75 13.5Z",
      "M11.1 11.1L15 15",
    ],
  },
  bath_and_body: {
    size: 18,
    strokeWidth: 2,
    paths: [
      "M7.5 3L6 4.5",
      "M12.75 14.25V15.75",
      "M1.5 9H16.5",
      "M5.25 14.25V15.75",
      "M6.75 3.75L5.71575 2.71575C5.49886 2.49785 5.22347 2.34747 4.92291 2.28281C4.62235 2.21814 4.30948 2.24196 4.02217 2.35138C3.73486 2.46079 3.48541 2.65112 3.304 2.89934C3.12259 3.14756 3.017 3.44303 3 3.75V12.75C3 13.1478 3.15804 13.5294 3.43934 13.8107C3.72064 14.092 4.10218 14.25 4.5 14.25H13.5C13.8978 14.25 14.2794 14.092 14.5607 13.8107C14.842 13.5294 15 13.1478 15 12.75V9",
    ],
  },
  nail_care: {
    size: 18,
    strokeWidth: 2,
    paths: [
      "M13.5 8.25V4.5C13.5 4.10218 13.342 3.72064 13.0607 3.43934C12.7794 3.15804 12.3978 3 12 3C11.6022 3 11.2206 3.15804 10.9393 3.43934C10.658 3.72064 10.5 4.10218 10.5 4.5",
      "M10.5 7.5V3C10.5 2.60218 10.342 2.22064 10.0607 1.93934C9.77936 1.65804 9.39782 1.5 9 1.5C8.60218 1.5 8.22064 1.65804 7.93934 1.93934C7.65804 2.22064 7.5 2.60218 7.5 3V4.5",
      "M7.5 7.875V4.5C7.5 4.10218 7.34196 3.72064 7.06066 3.43934C6.77936 3.15804 6.39782 3 6 3C5.60218 3 5.22064 3.15804 4.93934 3.43934C4.65804 3.72064 4.5 4.10218 4.5 4.5V10.5",
      "M13.5 6C13.5 5.60218 13.658 5.22064 13.9393 4.93934C14.2206 4.65804 14.6022 4.5 15 4.5C15.3978 4.5 15.7794 4.65804 16.0607 4.93934C16.342 5.22064 16.5 5.60218 16.5 6V10.5C16.5 12.0913 15.8679 13.6174 14.7426 14.7426C13.6174 15.8679 12.0913 16.5 10.5 16.5H9C6.9 16.5 5.625 15.855 4.5075 14.745L1.8075 12.045C1.54945 11.7592 1.41119 11.3851 1.42134 11.0002C1.4315 10.6153 1.58929 10.249 1.86204 9.97722C2.1348 9.70543 2.50163 9.54894 2.88658 9.54015C3.27153 9.53136 3.64512 9.67094 3.93 9.93L5.25 11.25",
    ],
  },
  brushes_and_tools: {
    size: 18,
    strokeWidth: 1.5,
    paths: [
      "M10.9665 13.4227L2.9565 11.238",
      "M13.782 1.9665C13.9298 1.81866 14.1053 1.70139 14.2985 1.62139C14.4917 1.54138 14.6987 1.5002 14.9078 1.5002C15.1168 1.5002 15.3238 1.54138 15.517 1.62139C15.7102 1.70139 15.8857 1.81866 16.0335 1.9665C16.1813 2.11434 16.2986 2.28984 16.3786 2.483C16.4586 2.67616 16.4998 2.88318 16.4998 3.09225C16.4998 3.30132 16.4586 3.50834 16.3786 3.7015C16.2986 3.89466 16.1813 4.07016 16.0335 4.218L13.02 7.23225C12.9497 7.30257 12.9102 7.39794 12.9102 7.49738C12.9102 7.59681 12.9497 7.69218 13.02 7.7625L13.728 8.4705C14.0669 8.80946 14.2573 9.26917 14.2573 9.7485C14.2573 10.2278 14.0669 10.6875 13.728 11.0265L13.02 11.7345C12.9497 11.8048 12.8543 11.8443 12.7549 11.8443C12.6554 11.8443 12.5601 11.8048 12.4897 11.7345L6.2655 5.511C6.1952 5.44068 6.1557 5.34531 6.1557 5.24588C6.1557 5.14644 6.1952 5.05107 6.2655 4.98075L6.9735 4.27275C7.31246 3.93384 7.77217 3.74344 8.2515 3.74344C8.73083 3.74344 9.19054 3.93384 9.5295 4.27275L10.2375 4.98075C10.3078 5.05105 10.4032 5.09054 10.5026 5.09054C10.6021 5.09054 10.6974 5.05105 10.7678 4.98075L13.782 1.9665Z",
      "M6.75 6C5.397 8.0325 3.7725 8.595 1.81275 8.961C1.74774 8.97287 1.68694 9.00148 1.63635 9.044C1.58577 9.08653 1.54714 9.14151 1.52427 9.20351C1.50141 9.26552 1.4951 9.33241 1.50597 9.3976C1.51684 9.46279 1.54451 9.52402 1.58625 9.57525L7.07625 16.2375C7.18776 16.3559 7.33475 16.4349 7.49506 16.4625C7.65537 16.4901 7.82031 16.4648 7.965 16.3905C9.55125 15.3037 12 12.594 12 11.25",
    ],
  },
  fragrance: {
    size: 18,
    strokeWidth: 1.5,
    paths: [
      "M2.25 2.25H2.2575",
      "M5.25 3.75H5.2575",
      "M8.25 5.25H8.2575",
      "M2.25 5.25H2.2575",
      "M5.25 6.75H5.2575",
      "M2.25 8.25H2.2575",
      "M11.25 3.75H14.25V6.75H11.25V3.75Z",
      "M14.25 6.75L15.75 8.25V15.75C15.75 16.2 15.45 16.5 15 16.5H10.5C10.05 16.5 9.75 16.2 9.75 15.75V8.25L11.25 6.75",
      "M9.75 10.5L15.75 9",
      "M9.75 14.25L15.75 12.75",
    ],
  },
  mens_grooming: {
    size: 18,
    strokeWidth: 1.5,
    paths: [
      "M14.25 15.75V14.25C14.25 13.4544 13.9339 12.6913 13.3713 12.1287C12.8087 11.5661 12.0456 11.25 11.25 11.25H6.75C5.95435 11.25 5.19129 11.5661 4.62868 12.1287C4.06607 12.6913 3.75 13.4544 3.75 14.25V15.75",
      "M12 5.25C12 6.90685 10.6569 8.25 9 8.25C7.34315 8.25 6 6.90685 6 5.25C6 3.59315 7.34315 2.25 9 2.25C10.6569 2.25 12 3.59315 12 5.25Z",
    ],
  },
  gift_sets: {
    size: 18,
    strokeWidth: 1.5,
    paths: [
      "M3 6H15C15.4142 6 15.75 6.33579 15.75 6.75V8.25C15.75 8.66421 15.4142 9 15 9H3C2.58579 9 2.25 8.66421 2.25 8.25V6.75C2.25 6.33579 2.58579 6 3 6Z",
      "M9 6V15.75",
      "M14.25 9V14.25C14.25 14.6478 14.092 15.0294 13.8107 15.3107C13.5294 15.592 13.1478 15.75 12.75 15.75H5.25C4.85218 15.75 4.47064 15.592 4.18934 15.3107C3.90804 15.0294 3.75 14.6478 3.75 14.25V9",
      "M5.625 6C5.12772 6 4.65081 5.80246 4.29917 5.45083C3.94754 5.09919 3.75 4.62228 3.75 4.125C3.75 3.62772 3.94754 3.15081 4.29917 2.79917C4.65081 2.44754 5.12772 2.25 5.625 2.25C6.34851 2.23739 7.05752 2.58844 7.65955 3.25737C8.26159 3.9263 8.72871 4.88205 9 6C9.27129 4.88205 9.73841 3.9263 10.3404 3.25737C10.9425 2.58844 11.6515 2.23739 12.375 2.25C12.8723 2.25 13.3492 2.44754 13.7008 2.79917C14.0525 3.15081 14.25 3.62772 14.25 4.125C14.25 4.62228 14.0525 5.09919 13.7008 5.45083C13.3492 5.80246 12.8723 6 12.375 6",
    ],
  },
  sparkles: {
    size: 18,
    strokeWidth: 1.5,
    paths: [
      "M9 2.25L7.566 6.60975C7.49261 6.83288 7.36785 7.03566 7.20175 7.20175C7.03566 7.36785 6.83288 7.49261 6.60975 7.566L2.25 9L6.60975 10.434C6.83288 10.5074 7.03566 10.6322 7.20175 10.7982C7.36785 10.9643 7.49261 11.1671 7.566 11.3903L9 15.75L10.434 11.3903C10.5074 11.1671 10.6322 10.9643 10.7982 10.7982C10.9643 10.6322 11.1671 10.5074 11.3903 10.434L15.75 9L11.3903 7.566C11.1671 7.49261 10.9643 7.36785 10.7982 7.20175C10.6322 7.03566 10.5074 6.83288 10.434 6.60975L9 2.25Z",
    ],
  },
  globe: {
    size: 18,
    strokeWidth: 1.5,
    paths: [
      "M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z",
      "M6 9C6 6.20756 7.07418 3.52212 9 1.5C10.9258 3.52212 12 6.20756 12 9C12 11.7924 10.9258 14.4779 9 16.5C7.07418 14.4779 6 11.7924 6 9Z",
      "M1.5 9H16.5",
    ],
  },
  truck: {
    size: 13,
    strokeWidth: 1.08333,
    paths: [
      "M7.58333 9.75V3.25C7.58333 2.96268 7.4692 2.68713 7.26603 2.48397C7.06287 2.2808 6.78732 2.16667 6.5 2.16667H2.16667C1.87935 2.16667 1.6038 2.2808 1.40063 2.48397C1.19747 2.68713 1.08333 2.96268 1.08333 3.25V9.20833C1.08333 9.35199 1.1404 9.48977 1.24198 9.59135C1.34357 9.69293 1.48134 9.75 1.625 9.75H2.70833",
      "M8.125 9.75H4.875",
      "M10.2917 9.75H11.375C11.5187 9.75 11.6564 9.69293 11.758 9.59135C11.8596 9.48977 11.9167 9.35199 11.9167 9.20833V7.23125C11.9164 7.10833 11.8744 6.98913 11.7975 6.89325L9.9125 4.537C9.86184 4.47356 9.79757 4.42232 9.72444 4.38707C9.65131 4.35181 9.57119 4.33345 9.49 4.33333H7.58333",
      "M9.20833 10.8333C9.80664 10.8333 10.2917 10.3483 10.2917 9.75C10.2917 9.15169 9.80664 8.66667 9.20833 8.66667C8.61002 8.66667 8.125 9.15169 8.125 9.75C8.125 10.3483 8.61002 10.8333 9.20833 10.8333Z",
      "M3.79167 10.8333C4.38998 10.8333 4.875 10.3483 4.875 9.75C4.875 9.15169 4.38998 8.66667 3.79167 8.66667C3.19336 8.66667 2.70833 9.15169 2.70833 9.75C2.70833 10.3483 3.19336 10.8333 3.79167 10.8333Z",
    ],
  },
  package: {
    size: 16,
    strokeWidth: 1.33333,
    paths: [
      "M5 2.84667L11 6.28",
      "M14 5.33333C13.9998 5.09952 13.938 4.86987 13.821 4.66744C13.704 4.46501 13.5358 4.29691 13.3333 4.18L8.66667 1.51333C8.46397 1.39631 8.23405 1.3347 8 1.3347C7.76595 1.3347 7.53603 1.39631 7.33333 1.51333L2.66667 4.18C2.46418 4.29691 2.29599 4.46501 2.17897 4.66744C2.06196 4.86987 2.00024 5.09952 2 5.33333V10.6667C2.00024 10.9005 2.06196 11.1301 2.17897 11.3326C2.29599 11.535 2.46418 11.7031 2.66667 11.82L7.33333 14.4867C7.53603 14.6037 7.76595 14.6653 8 14.6653C8.23405 14.6653 8.46397 14.6037 8.66667 14.4867L13.3333 11.82C13.5358 11.7031 13.704 11.535 13.821 11.3326C13.938 11.1301 13.9998 10.9005 14 10.6667V5.33333Z",
      "M2.2 4.66667L8 8L13.8 4.66667",
      "M8 14.6667V8",
    ],
  },
  trend: {
    size: 16,
    strokeWidth: 1.33333,
    paths: [
      "M14.6667 4.66667L9 10.3333L5.66667 7L1.33333 11.3333",
      "M10.6667 4.66667H14.6667V8.66667",
    ],
  },
  "arrow-left": {
    size: 16,
    strokeWidth: 1.33333,
    paths: ["M8 12.6667L3.33333 8L8 3.33333", "M12.6667 8H3.33333"],
  },
  "arrow-right": {
    size: 16,
    strokeWidth: 1.33333,
    paths: ["M3.33333 8H12.6667", "M8 3.33333L12.6667 8L8 12.6667"],
  },
  check: {
    size: 12,
    strokeWidth: 1,
    paths: ["M10 3L4.5 8.5L2 6"],
  },
} satisfies Record<string, IconData>;

export type OnboardingIconName = keyof typeof ICONS;

type OnboardingIconProps = {
  name: OnboardingIconName;
  // Rendered size in px; defaults to the size it was drawn at in Figma.
  size?: number;
} & Omit<SVGProps<SVGSVGElement>, "name">;

export function OnboardingIcon({ name, size, ...props }: OnboardingIconProps) {
  const icon: IconData = ICONS[name];
  const renderedSize = size ?? icon.size;
  return (
    <svg
      width={renderedSize}
      height={renderedSize}
      viewBox={`0 0 ${icon.size} ${icon.size}`}
      fill="none"
      stroke="currentColor"
      strokeWidth={icon.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      {...props}>
      {icon.paths.map((path) => (
        <path key={path} d={path} />
      ))}
    </svg>
  );
}
